<template>
  <v-row justify="center" class="px-4">
    <v-col cols="12" md="10">
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-text-field label="search" outlined dense v-model="search" hide-details>
                <template v-slot:prepend-inner>
                  <v-icon class="pr-2">search</v-icon>
                </template>
                <template v-slot:append>
                  <v-icon class="pr-2" @click="search = null"> cancel</v-icon>
                </template>
              </v-text-field>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon x-large color="primary" @click="inviteDialog = true" v-if="$vuetify.breakpoint.lgAndUp">person_add</v-icon>
              <v-icon x-large color="primary" @click="share" v-else>person_add</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-row class="pa-4" justify="space-between">
          <v-col cols="12" md="6" :order="$vuetify.breakpoint.smAndUp?1:2">
            <v-treeview :active.sync="active" :items="items" :load-children="fetchUsers" :open.sync="open" activatable color="primary" open-all transition>
              <template v-slot:prepend="{ item }">
                <v-icon v-if="!item.children">
                  mdi-account
                </v-icon>
              </template>
            </v-treeview>
          </v-col>
          <v-col class="d-flex " :order="$vuetify.breakpoint.smAndUp?2:1">
            <v-scroll-y-transition mode="out-in">
              <div v-if="!selected" class="title grey--text text--lighten-1 font-weight-light" style="align-self: center;">
                Select a User
              </div>
              <v-card v-else :key="selected._key" class=" mx-auto" max-width="400">
                <v-card-text>
                  <v-list-item>
                    <v-list-item-avatar size="80">
                      <v-img :src="selected.photoURL"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="title pl-1">
                        {{ selected.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="subtitle py-1">
                        <v-row no-gutters align="baseline">
                          <v-rating v-model="selected.rating" small dense half-increments color="primary" background-color="primary" readonly></v-rating>
                          <span class="px-2">({{ selected.rating }})</span>
                        </v-row>
                        <v-row no-gutters class="pl-1 pt-1">

                          {{ selected.reviewCount ? selected.reviewCount + `${ $language.settings['reviews'] }.` : `${ $language.settings['No reviews'] }.` }}
                        </v-row>
                        <v-row no-gutters class="pl-1 pt-1">
                          {{ selected.completedJobs ? selected.completedJobs + `${ $language.settings['completed jobs'] }.` : `${ $language.settings['No completed jobs'] }.` }}

                        </v-row>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
                <v-divider></v-divider>
                <v-row justify="center" class="pa-8">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2">
                        {{$language.settings['E-mail']}}:
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <a :href="`mailto:${selected.email}`">
                        {{ selected.email }}
                      </a>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2">
                        {{$language.registration['Company Name']}}:
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      {{ selected.companyName }}
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2">
                        {{$language.favorites['Mobile Phone']}}:
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <a :href="`tel:+1${selected.mobilePhone}`">
                        {{ selected.mobilePhone }}
                      </a>
                    </v-list-item-action>
                  </v-list-item>
                </v-row>
              </v-card>
            </v-scroll-y-transition>
          </v-col>
        </v-row>
      </v-card>
      <!-- <v-card flat class="pa-2" width="100%">
        <v-layout wrap>
          <v-flex xs10 sm6 pl-1>
            <v-card>
              <div class="v-input v-text-field theme-- v-text-field--single-line v-text-field--solo v-text-field--solo-flat v-text-field--enclosed">
                <div class="v-input__control">
                  <div class="v-input__slot mb-0 pb-0">
                    <v-btn text icon color="primary lighten-1" class="mx-0 pr-1 mt-0 pt-1">
                      <v-icon medium class="pr-0">search</v-icon>
                    </v-btn>
                    <input placeholder="search" v-model="search" />
                    <v-btn text icon color="primary lighten-1" class="mx-0 pr-0 mt-0 pt-1" @click="search = null">
                      <v-icon medium class="pr-0">cancel</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs2 v-ripple>
            <v-layout row justify-center pt-1 pl-2>
              <v-icon x-large color="primary" @click="share">person_add</v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card> -->

      <!-- <v-list v-if="filteredItems.length!==0">
        <template v-for="(item,index) in filteredItems">
          <favorite-list-item class="my-2" :dark="true" :key="item" :profile-id="item" :show-add="false" @profile="openProfileDialog(item)"></favorite-list-item>
          <v-divider inset v-if="index!==filteredItems.length-1" :key="index"></v-divider>
        </template>
      </v-list> -->

      <v-dialog v-model="profileDialog" fullscreen persistent :overlay="false" transition="dialog-transition">
        <profile :userFav="userProfile.favorites" :profileRef="thisProfile" :job="null" @simple-close="profileDialog = false"></profile>
      </v-dialog>

      <v-dialog v-model="inviteDialog" max-width="290">
        <v-card class="py-1">
          <v-card-title class="headline">{{ $language.favorites['Invite Worker'] }}</v-card-title>
          <v-card-text class="mt-2">
            <!-- <v-text-field v-model="email" :rules="emailRules" label="E-mail"></v-text-field> -->
            <v-text-field v-model="mobilePhone" mask="phone" outlined type="number" :rules="phoneRules" :label="$language.favorites['Mobile Phone']">
              <template v-slot:prepend-inner>
                <v-icon color="primary" class="pr-2">phone</v-icon>
              </template>
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click.native="inviteDialog = false">{{ $language.favorites['cancel'] }}</v-btn>
            <v-btn color="primary" depressed @click.native="sendInvite">{{ $language.favorites['Send Invite'] }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
// import FavoriteListItem from '@/components/jefe/FavoriteListItem'
import Profile from '@/components/common/Profile'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    // FavoriteListItem,
    Profile
  },
  data () {
    return {
      profileDialog: false,
      thisProfile: {},
      inviteDialog: false,
      email: '',
      mobilePhone: '',
      emailRules: [
        v => /.+@.+/.test(v) || this.$language.validations['E-mail must be valid']
      ],
      phoneRules: [
        (v) => !!v || 'Phone number is required',
        (v) => v.length === 10 || 'Must be a valid US phone number.'
      ],
      text: this.$language.favorites['Invite Sent!'],
      snack: false,
      search: null,
      filteredItems: [],
      active: [],
      open: [],
      users: []

    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser']),
    selected () {
      if (!this.active.length) return undefined
      const id = this.active[0]
      return this.users.find(user => user.id === id)
    },
    items () {
      return [
        {
          name: 'Favorites',
          children: this.filteredItems
        }
      ]
    },
    emailRef () {
      var subject = `${((this.userProfile || {}).public || {}).name} would like to invite you to Hefe`
      var body = `Follow the link ${(this.userProfile || {}).referralShortLink}`
      return `mailto:?subject=${subject}&body=${body}`
    }

  },
  methods: {
    async fetchUsers () {
      return Promise.all(
        Object.keys((this.userProfile || {}).favorites || {}).map((k) => {
          return fb.database.ref(`/user/${k}/profile/public`).once('value').then((snapshot) => {
            var item = snapshot.val()
            item.id = k
            this.users.push(item)
            this.filteredItems.push(item)
          }).catch((err) => {
            console.log(err)
          })
        }))
    },

    share () {
      if (navigator.share) {
        navigator.share({
          title: 'Hefe App',
          text: 'Check out Hefe. ',
          url: this.userProfile.referralShortLink
        })
          .then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing', error))
      }
    },

    processFavorites (favorites) {
      return Object.keys(favorites).map(k => k).filter(item => item !== 'alive')
    },

    sendInvite () {
      var invite = {
        'mobilePhone': this.mobilePhone,
        'inviteURL': this.userProfile.referralShortLink,
        'invitedBy': this.userProfile.public.name,
        'creationDate': new Date()
      }
      var inviteKey = fb.database.ref().child(`/user/${this.currentUser.uid}/profile/invites`).push().key
      var updates = {}
      updates[`/user/${this.currentUser.uid}/profile/invites/${inviteKey}`] = invite
      fb.database.ref().update(updates)
      this.snack = true
      this.inviteDialog = false
      this.mobilePhone = ''
    },

    openProfileDialog (data) {
      this.profileDialog = true
      this.$nextTick(() => {
        this.thisProfile = {
          profileId: data
        }
      })
    },
    clear () {
      this.filteredItems = this.users.sort((a, b) => {
        return a.name > b.name ? 1 : -1
      })
    }
  },
  watch: {
    search () {
      if (this.search) {
        this.filteredItems = this.users.filter(item => {
          return item.name.toLowerCase().match(this.search)
        }).sort((a, b) => {
          return a.name > b.name ? 1 : -1
        })
      } else {
        this.filteredItems = this.users.filter(item => item !== 'alive').sort((a, b) => {
          return a.name > b.name ? 1 : -1
        })
      }
    }
  },
  filters: {
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },
    trimLength (val) {
      if (val.length < 200) {
        return val
      }
      return `${val.substring(0, 200)}...`
    }
  }
}
</script>
